module.exports = __webpack_public_path__ + "static/media/cutsglare_portuguese_00113.699589aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/pr/cutsglare_portuguese_00113.png
// module id = 2039
// module chunks = 0